
const NotFound = () => {

    return (
        <div>
           <h1>///////////////////////////////////NOT FOUND</h1>
        </div>
    )

}

export default NotFound;